<div style="display:inline">

  <h1 mat-dialog-title>
    <button mat-button mat-raised-button class="columnButton">
      <span class="material-symbols-outlined  columnIcon">
        dashboard_customize
      </span>
    </button>
    <span style="padding:10px;">Visible Columns</span>
  </h1>
</div>
<div mat-dialog-content style="overflow:hidden">
  <div class="columnSelectHead">
    <span>Input</span>
  </div>
  <div class="columnSelectHead">
    <span>Output</span>
  </div>
  <div class="columnSelectHead">
    <span>Other</span>
  </div>
  <div class="columnSelect colSep">
    <div *ngFor="let col of inputColumns">
      <mat-checkbox [checked]="col.visible" [disabled]="!col.canBeRemoved || (visibleColumnCount >= MAXSELECTED && !col.visible)" (change)="selectionChange($event, col)">{{col.userReadableName}}</mat-checkbox>
    </div>
  </div>
  <div class="columnSelect colSep">
    <div *ngFor="let col of outputColumns">
      <mat-checkbox [checked]="col.visible" [disabled]="!col.canBeRemoved || (visibleColumnCount >= MAXSELECTED && !col.visible)" (change)="selectionChange($event, col)">{{col.userReadableName}}</mat-checkbox>
    </div>
  </div>
  <div class="columnSelect colLast">
    <div *ngFor="let col of otherColumns">
      <mat-checkbox [checked]="col.visible" [disabled]="!col.canBeRemoved || (visibleColumnCount >= MAXSELECTED && !col.visible)" (change)="selectionChange($event, col)">{{col.userReadableName}}</mat-checkbox>
    </div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="selectDefaults()">
    <span>Select Defaults</span>
  </button>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" mat-raised-button color="primary">Save</button>
</div>
